//Componentes generales
import React, { useState, useMemo, useEffect, useContext, useRef } from "react";
import { FixedSizeList } from "react-window";

//Componentes generales
import SearchInput from '../../components/searchInput/SearchInput';
import StateChange from '../../components/StateChange/StateChange';
import ReqInfo from "../ReqInfo/ReqInfo";
import FilterScreen from "../filterScreen/FilterScreen";
import AddFilter from "../addFilter/AddFilter";
import normalizeText from "../../utils/normalizeText";
import FormReq from "../FormReq/FormReq";
import RRReq from "../renderRows/RRReqs";

//api
import {getODTByNroFor, getTransactionDocumentsByFilter, getFiles, deleteTDoc} from '../../api/transactionDocuments'
// context
import controlContext from '../../context/control/controlContext';
import activoContext from "../../context/activoContex/activoContex";
//Estilos
import './ReqList.css';
import {COLOR_BTN} from '../../constants/colors';

//Estados
import { STATES } from '../../utils/states';
import { constants } from "buffer";
import { estructura_producto } from "../../utils/estructuras";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faSpinner } from "@fortawesome/free-solid-svg-icons";
import authContext from "../../context/authentication/authContex";
import { text } from "@fortawesome/fontawesome-svg-core";
import Swal from "sweetalert2";
import { Calendar } from "../calendar/Calendar";
import moment from "moment";

/* 
    Componente encargado de mostrar el listado de requerimientos.
        Donde currentUser es el usuario en sesión.
              listTDoc es la lista de requerimientos.
              modificarEstado es la función del context encargarda de realizar una modificación de un campo especifico.
              verDetalle es la función que recupera el detalle de un requerimiento.
              filtros es el filtro donde se aplican las modificaciones por el usuario.
              aplicarFiltros es la función del context que aplica los filtros.
              productList es la lista de productos disponibles.
              generaPDF es la función del context que genera y descarga un archivo pdf.
              checkPermisos es la función del context que chequea si el usuario en sesión tiene permisos.
              guardarComo es la función del context encargada de guardar un requerimiento generado por un "repetir".
              editar es la función del context encargada de guardar un requerimiento generado por un "editar".
              eventoClickEdicion en la función del context que recupera los datos de un requerimiento a editar.
              recuperaFilesDetalle es la función del context que recupera los archivos de un requerimiento.
              sendToAPI es la función del context que envia la solicitud de enviar el requerimiento a Softland.
*/
function ReqList({ 
    currentUser, 
    listTDoc, 
    userListView, 
    modificarEstado, 
    verDetalle, 
    filtros, 
    aplicarFiltros, 
    productList, 
    generaPDF, 
    checkPermisos, 
    guardarComo, 
    editar, 
    recuperaFilesDetalle, 
    sendToAPI,
    editOT,
    nroforToEdit,
    OTtoFind,
    ordenesTrabajoFromLocalStorage,
    checklistsRegFromLocalStorage
}) {
    //stata que uarda el transactiondocuments el que fue seleccionado
    const [transDocId, setTransDocId] = useState({
            state:"",
            fecAlt:"",
            fecMod:"",
            observ:"",
            tDocCodFor:"",
            tDocNroFor:"",
            quantity:"",
            dateOfIssue:"",
            tDocUserID:"",
            userName:"",
            priority:"",
            title:"",
            deliveryDate:"",
            notePriv:"",
            notePubl:"",
            enviado: ""  
    })

    //Context control requerimientos
    const cContext = useContext(controlContext);
    const { getProductsByNroFor, getODTByNrofor, cargando, getAndMergeTDocsByFecAlt } = cContext;

    const {calcularMantenimientos} = useContext(activoContext);

    const {usuario} = useContext(authContext);

    //datos de trancioDoc con su activo
    const [tranDocAct, setTranDocAct] = useState();

    //state para marcar el requerimiento seleccionado.
    const [selected, setSelected] = useState("");
    //state para mostrar dialog de Edición.
    const [selectedEdit, setSelectedEdit] = useState(false);
    //state para mostrar dialog de cambio de Estado.
    const [selectedState, setSelectedState] = useState("");
    //State para mostrar calendario.
    const [showCalendar, setShowCalendar] = useState(false);
    //state para mostrar dialog de filtro. 
    const [selectedFilter, setSelectedFilter] = useState("");
    //state para mostrar dialog de formulario requerimiento (guardar como).
    const [selectedRepeat, setSelectedRepeat] = useState("");
    //state para filtros.
    const [filter, setFilter] = useState(OTtoFind ? OTtoFind : '');
    //state de workspaces seleccionado (Ya definidos: Abiertas, Pendientes, En Proceso y Todos).
    const [activeWorkSpace, setActiveWorkSpace] = useState({abiertas: 1, todos: 0, pendientes: 0, disponibles:0 });
    //state para definir estados no enviables.
    const [stateNoEnviables, setStatesNoEnviable] = useState(["PENDIENTE", "RECHAZADO"]);
    //state para definir tamaño para lista.
    const [itemSize, setItemSize] = useState(300);

    const [selct,setSelec] = useState([])

    // Calcula el valor del height según el tamaño de la pantalla y el tamaño del navbar
    const listHeight = useMemo(() => window.innerHeight - 210, []);

    const monthsAlreadyLoaded = useRef([moment().format('YYYY-MM')]);

    /* 
        Manejador que setea el  filtro de busqueda.
            Donde data es lo ingresado por el usuario.
    */
    const handdlerSearchInput = (data) => {
        setFilter(data);
    }

    /* 
        Manejador que abre/cierra dialog de información del requerimiento seleccionado.
            Donde item es el requerimiento seleccionado.
        En este punto, se recuperan los archivos adjuntados al requerimiento.
    */
    const handlerDetails = async (item) => {
        setSelected(null);
        if(item){
            console.log(item);
            
            const files = await recuperaFilesDetalle(item);
            const reqActualizado = await getODTByNrofor(item.tDocNroFor);
            setSelected({item:reqActualizado.data.data, files});
        }
    }

    /* 
        Función encargada de mostrar el dialog de formulario de requerimiento.
        Donde item es el requerimiento del que se hace un guardar como.
        prods es la lista de productos del requerimiento.
        agregaItemF es la función de agrega itm (No esta en uso).
        Se setea el estado del requerimiento como pendieente y se agrega al titulo el prefijo "Copia" junto al numero del requerimiento repetido.
    */
    const repeat = async (item, prods, agregaItemF) => {
        setSelectedRepeat(null);
        if(item){
            const {tDocCodFor, tDocNroFor, _id, title, ...rest} = item;
            const nuevaListaP = prods.map((p) => {
                const { _id, ...rest} = p; 
                return rest;
            })
            setSelectedRepeat({item:{...rest, title: `Copia ${tDocCodFor}-${tDocNroFor} ${title}`, state:"PENDIENTE"}, nuevaListaP, agregaItemF});
        }
    }

    /* 
        Manejador que abre/cierra el dialog de formulario en modo guardar como.
            Donde item es el requerimiento.
    */
    const handlerRepeat = async (item) => {
        setSelectedRepeat(null);
        if(item){
            setSelectedRepeat(item);
            guardarComo(item);
        }
    }

    /* 
        Manejador que abre/cierra el dialog de formulario en modo edición.
            Donde req es el requerimiento a editar.
                  agregaItemF es la función de agrega itm (No esta en uso).
        En este punto se recuperan los items y archivos.
    */

    const handlerEdit = async (tDocNroFor) => {
        if(tDocNroFor){
            const res = await getTransactionDocumentsByFilter(tDocNroFor)
            const resFiles = await getFiles('ODT',tDocNroFor);
            let filesObtained = resFiles.data?.data;
            if(Array.isArray(filesObtained) && filesObtained.length > 0){
                setSelectedEdit({files:filesObtained});
            } 
            else setSelectedEdit(!selectedEdit);
            let productos = res.data.products;
            setTranDocAct({...res.data.data,productos:productos})
        }else{
            setSelectedEdit(false);
        }
    }

    const handleDelete = async (nroFor,tDocID,state) => {
        if(tDocID){
            Swal.fire({
                title: `Está seguro que desea eliminar la ODT ${nroFor}?`,
                showDenyButton: true,
                confirmButtonText: 'Sí, estoy seguro',
                confirmButtonColor: '#ff0000',
                denyButtonColor: '#3d4d87',
                denyButtonText: 'No',
            })
            .then(async (res) => {
                if (res.isConfirmed) {
                    const res = await deleteTDoc(nroFor,tDocID,state);
                    if(res.data?.success){
                        calcularMantenimientos();
                        Swal.fire({
                            title:'ODT Eliminada!',
                            html: res.data.msg,
                            icon:'success'
                        })
                    }else{
                        Swal.fire({
                            title:'Ops!',
                            html: res.data.msg,
                            icon:'error'
                        })
                    }
                }
            })
        }
    }


    /* 
        Manejador que abre/cierra el dialog de cambio de estado.
            Donde item es el requerimiento.
    */
    const handlerState = async (item) => {
        if(item){
            const resV2 = await getODTByNroFor(item.tDocNroFor);
            if(resV2.data && resV2.data.data?.codActivo){
                setSelectedState(resV2.data.data);
            }else setSelectedState(item);
        }else setSelectedState(null);
    }

    /* 
        Manejador que abre/cierra el fialog de filtros.
            Donde itm es un booleano que determina si se ve o no.
    */
    const handlerClickFilter = (itm) => {
        setSelectedFilter(itm)
    }

    /* 
        Manejador encargado de abrir en una nueva ventana el archivo seleccionado.
    */
    const handlerAbrirURL = (url) => {
        window.open(url);
    }

    /*
        Manejador que setea los filtros de estado marcando "PENDIENTE" y "ENPROCESO" si el usuario clickea el workspace "Abiertas".
    */
    const handleWorkSpaceAbiertas = () =>{
        setSelec([]);
        setActiveWorkSpace({abiertas: 1, todos: 0, pendientes: 0, ennivel3: 0});
        const estado = ["PENDIENTE", "ENPROCESO"];
        const filterEstado = {...filtros.filtrosEstado, activos: usuario.activosAllowed.map(a => a.value), state: estado};
        // Se mantiene el rango de fechas actualmente activo (p.ej. los ultimos 4 meses del
        // Home): estos tabs solo cambian el filtro de estado, no deben resetear fecAlt al
        // rango amplio por defecto.
        const filterRango = filtros.filtrosRango;
        aplicarFiltros({filterRango, filterEstado},'');
    }

    /*
        Manejador que setea los filtros de estado marcandolos todos si el usuario clickea el workspace "Todos".
    */
    const handleWorkSpaceTodos = () =>{
        setSelec([]);
        setActiveWorkSpace({abiertas: 0, todos: 1, pendientes: 0, ennivel3: 0});
        const filterEstado = {...filtros.filtrosEstado, activos: usuario.activosAllowed.map(a => a.value), state: STATES };
        // Se mantiene el rango de fechas actualmente activo (p.ej. los ultimos 4 meses del
        // Home): estos tabs solo cambian el filtro de estado, no deben resetear fecAlt al
        // rango amplio por defecto.
        const filterRango = filtros.filtrosRango;
        aplicarFiltros({filterRango, filterEstado},'');
    }

    /*
        Manejador que setea los filtros de estado marcandolo solo el estado "Pendientes" si el usuario clickea el workspace "Pendientes".
    */
    const handleWorkSpacePendientes = () =>{
        setSelec([]);
        setActiveWorkSpace({abiertas: 0, todos: 0, pendientes: 1, ennivel3: 0});
        const estado = ["PENDIENTE"];
        const filterEstado = {...filtros.filtrosEstado, activos: usuario.activosAllowed.map(a => a.value), state: estado};
        // Se mantiene el rango de fechas actualmente activo (p.ej. los ultimos 4 meses del
        // Home): estos tabs solo cambian el filtro de estado, no deben resetear fecAlt al
        // rango amplio por defecto.
        const filterRango = filtros.filtrosRango;
        aplicarFiltros({filterRango, filterEstado},'');
    }

    /*
        Manejador que setea los filtros de estado marcandolo solo el estado "EnNivel3" si el usuario clickea el workspace "EnNivel3".
    */
    const handleWorkSpaceEnNivel3 = () =>{
        setSelec([]);
        setActiveWorkSpace({abiertas: 0, todos: 0, pendientes: 0, ennivel3: 1});
        const estado = ["ENPROCESO"];
        const filterEstado = {...filtros.filtrosEstado, activos: usuario.activosAllowed.map(a => a.value), state: estado};
        // Se mantiene el rango de fechas actualmente activo (p.ej. los ultimos 4 meses del
        // Home): estos tabs solo cambian el filtro de estado, no deben resetear fecAlt al
        // rango amplio por defecto.
        const filterRango = filtros.filtrosRango;
        aplicarFiltros({filterRango, filterEstado},'');
    }

    useEffect(()=>{
        if(editOT == 'fromProcProgramado'){
            handlerEdit(nroforToEdit);
        }
    },[editOT])

    return (
        <div>
            <div className="navbar-reqList">
                <div className={activeWorkSpace.abiertas ? "navbar-container-reqList-active" : "navbar-container-reqList"} onClick={handleWorkSpaceAbiertas}>
                    <div className="navbar-item-reqList">
                        <div className='navbar-item-label-xx' >ABIERTAS</div>
                    </div>
                </div>
                <div className={activeWorkSpace.todos ? "navbar-container-reqList-active" : "navbar-container-reqList"}  onClick={handleWorkSpaceTodos} >
                    <div className="navbar-item-reqList">
                        <div className='navbar-item-label-xx' >TODOS</div>
                    </div>
                </div>
                <div className={activeWorkSpace.pendientes ? "navbar-container-reqList-active" : "navbar-container-reqList"} onClick={handleWorkSpacePendientes}>
                    <div className="navbar-item-reqList">
                        <div className='navbar-item-label-xx' >PENDIENTES</div>
                    </div>
                </div>
                <div className={activeWorkSpace.ennivel3 ? "navbar-container-reqList-active" : "navbar-container-reqList"} onClick={handleWorkSpaceEnNivel3}>
                    <div className="navbar-item-reqList">
                        <div className='navbar-item-label-xx' >EN PROCESO</div>
                    </div>
                </div>
            </div>
            <div className="utilitesDivReqs">
                <FilterScreen verFiltro={handlerClickFilter}/>
                {cargando && <FontAwesomeIcon icon={faSpinner} pulse className="rrIcon loadingReqList" id="progIcon"/>}
                <SearchInput buscar={handdlerSearchInput} filter={filter}/>
                <button onClick={()=>setShowCalendar(!showCalendar)} className="calendarBtn">CALENDARIO <FontAwesomeIcon icon={faCalendar}/></button>
            </div>
            {(listTDoc == undefined || listTDoc == null) ? <h3 className='warningStatusMsg'>Cargando<span>.</span><span>.</span><span>.</span></h3> : (listTDoc.length == 0) ? <h3 className='warningStatusMsg'>No hay órdenes de trabajo para mostrar</h3> : <div className='container-requests-list'>
                <div className="reqList">
                    {listTDoc.filter((r,i) => (filter != '' && filter.charAt(0) == '"' && filter.charAt(filter.length - 1) == '"') ? (normalizeText(`${r.tDocCodFor} - ${r.tDocNroFor}`) == normalizeText(filter.replaceAll('"','')) || normalizeText(r.title) == normalizeText(filter.replaceAll('"','')) || normalizeText(r.tDocNroFor.toString()) == normalizeText(filter.replaceAll('"','')) || normalizeText(r.codActivo ?? '') == normalizeText(filter.replaceAll('"',''))) : (normalizeText(r.title).includes(normalizeText(filter)) || normalizeText(r.tDocNroFor.toString()).includes(normalizeText(filter)) || normalizeText(`${r.tDocCodFor} - ${r.tDocNroFor}`).includes(normalizeText(filter)) || normalizeText(r.codActivo ?? '').includes(normalizeText(filter))))
                    .map((r,i) => <RRReq key={i} item={r} currentUser={currentUser}  index={i} listTDoc={listTDoc} filter={filter} checkPermisos={checkPermisos} cambiarEstado={handlerState} editar={handlerEdit} deleteTDoc={handleDelete} verDetalles={handlerDetails} statesNEviables={stateNoEnviables} sendToAPI={sendToAPI}/>)}
                </div>

            </div>}
            {selectedFilter &&
                <div className="addFilterContainer">
                    <AddFilter 
                        usuarios={userListView} 
                        item={selectedFilter} 
                        cerrar={handlerClickFilter} 
                        filtro={filtros} 
                        aplicarFiltros={aplicarFiltros} 
                        workspace={activeWorkSpace} 
                        selct={selct}
                        setSelec={setSelec}
                    />
                </div>
            }
            {selected &&
                <div className="modalContainer">
                    <ReqInfo item={selected.item} files={selected.files} cerrar={handlerDetails} verDetalle={verDetalle} repetir={repeat} generaPDF={generaPDF} abrirURL={handlerAbrirURL} guardarModificaciones={modificarEstado} usuario={currentUser} />
                </div>
            }            
            {selectedRepeat &&
                <div className="modalReq">
                   <FormReq edicion={"Guardar_Como"}   req={selectedRepeat.item} itemList={selectedRepeat.nuevaListaP} productList={productList} guardarReq={guardarComo} cerrar={handlerRepeat} verDetalle={verDetalle} />
                </div>
            }
            {selectedEdit &&
                <div className="modalContainer">
                   <FormReq edicion={"Edicion"}  req={tranDocAct} itemList={selectedEdit.nuevaListaP} 
                    files={selectedEdit.files} guardarReq={editar} productList={productList} cerrar={handlerEdit} 
                    verDetalle={verDetalle}  transDocId={transDocId}  setTranDocAct={setTranDocAct}/>
                </div>
            }
            {selectedState &&
                <div className="modalContainer">
                    <StateChange item={selectedState} guardarEstado={(r, state) => modificarEstado(r, { state: state, fechaCompletado: r.fechaCompletado ? r.fechaCompletado : '' })} cerrar={handlerState} currentUser={currentUser}/>
                </div>
            }
            {
                showCalendar && <div className="modalContainer">
                    <Calendar data={listTDoc} getAndMergeTDocsByFecAlt={getAndMergeTDocsByFecAlt} setShowCalendar={setShowCalendar} handlerDetails={handlerDetails} monthsAlreadyLoaded={monthsAlreadyLoaded} editar={editar}/>
                </div>
            }
        </div>

    );
}

export default ReqList